// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { Auth, getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC0Se8LkEhsJQpYPiatQvKuasAtzr7Ujyw",
  authDomain: "rogo-system.firebaseapp.com",
  databaseURL: "https://rogo-system.firebaseio.com",
  projectId: "rogo-system",
  storageBucket: "rogo-system.appspot.com",
  messagingSenderId: "224096425240",
  appId: "1:224096425240:web:803e4f5630ca119b183a6d",
  measurementId: "G-NVS0WDPN7B",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth: Auth = getAuth(app);
const analytics = getAnalytics(app);
